export const getPortalLinkConfig = ({
  primaryProduct,
  permittedProducts = "",
  dashboardSources = "",
  intelliDashFlag,
  intelliCastFlag,
  portalUrl,
  dashboardUrl
}) => {

  // ---------------- NORMALIZER ----------------
  const normalize = (v) =>
    String(v ?? "").trim().toLowerCase();

  // ---------------- SAFE CSV PARSER ----------------
  const parseCSV = (value) => {
    if (!value) return [];

    if (Array.isArray(value)) {
      return value.map(normalize).filter(Boolean);
    }

    if (typeof value === "string") {
      return value.split(",").map(normalize).filter(Boolean);
    }

    return [];
  };

  // ---------------- NORMALIZED INPUTS ----------------
  const primary = normalize(primaryProduct);
  const permitted = parseCSV(permittedProducts);
  const sources = parseCSV(dashboardSources);

  // ---------------- GLOBAL ENABLE CHECK ----------------
  const isEnabled =
    Number(intelliDashFlag) === 1 ||
    Number(intelliCastFlag) === 1;

  if (!isEnabled) {
    return { visible: false };
  }

  // ---------------- PERMISSION + FLAG COMBO ----------------
  const hasIntelliDashPermission =
    permitted.includes("intellidash") &&
    Number(intelliDashFlag) === 1;

  // ---------------- STRICT SAFETY RULE ----------------
  const hasSafetyIncident =
    sources.length > 0 &&
    sources.every(s => s === "safety incidents");

  // ======================================================
  // RULE ENGINE (ORDERED + SAFE)
  // ======================================================

  // ---------------- RULE 1: IntelliDash ----------------
  const isIntelliDashPrimary =
    primary === "intellidash";

  if (isIntelliDashPrimary && hasIntelliDashPermission) {
    return {
      visible: true,
      text: "Go to IntelliDash Analytics Portal",
      url1: portalUrl,
      openInNewTab: true
    };
  }

  // ---------------- RULE 2: AristoCAST + Safety ONLY ----------------
  const isAristoCastPrimary =
    primary === "aristocast";

  if (
    isAristoCastPrimary &&
    hasIntelliDashPermission &&
    hasSafetyIncident
  ) {
    return {
      visible: true,
      text: "Manage Safety Incidents Records",
      url1: portalUrl,
      url2: dashboardUrl,
      openInNewTab: true
    };
  }

  // ---------------- RULE 3: AristoCAST fallback ----------------
  if (isAristoCastPrimary && hasIntelliDashPermission) {
    return {
      visible: true,
      text: "Go to IntelliDash Analytics Portal",
      url1: portalUrl,
      openInNewTab: true
    };
  }

  return { visible: false };
};